import styled from 'styled-components';
import { colorOpacity, colorShade } from '../../utils/style';

interface ProgressBarProps {
    className?: string;
    value?: number | 'indeterminate'
    orientation?: 'horizontal' | 'vertical';
    size?: number;
}

const orientationToTransform = { horizontal: 'scaleX', vertical: 'scaleY' }
const orientationToSize = { horizontal: 'height', vertical: 'width' }

export default function ProgressBar({ value = 0, orientation = 'horizontal', size = 3, className = '' }: ProgressBarProps) {
    return (
        <Wrapper className={`${className} progress-bar orientation-${orientation}`} style={{ [orientationToSize[orientation]]: size }}>
            <div
                className='progress-bar-bar'
                style={{
                    ...(value !== 'indeterminate' ? { transform: `${orientationToTransform[orientation]}(${value / 100})` } : { animation: `progress-bar-indeterminate-${orientation} 2s infinite linear`, transformOrigin: 'center' }),

                }}
            ></div>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    background-color: ${props => props.theme.backgroundColor};
    background-color: ${props => colorOpacity(props.theme.primaryColor, 0.2)};
    border-radius: ${props => props.theme.borderRadius};
    overflow: hidden;

    &.orientation-horizontal {height: 3px;}
    &.orientation-vertical {width: 3px; height: 100%;}

    .progress-bar-bar {
        background-color: ${props => props.theme.primaryColor};
        height: 100%;
        width: 100%;
        transform: scaleX(0.2);
        transition: transform 0.2s;
        transform-origin: left bottom;
    }

    @keyframes progress-bar-indeterminate-horizontal { 0%, 100% {transform: translateX(-50%) scaleX(0.2);} 25%, 75% {transform: scaleX(0.4);} 50% {transform: translateX(50%) scaleX(0.2)} }
    @keyframes progress-bar-indeterminate-vertical { 0%, 100% {transform: translateY(-50%) scaleY(0.2);} 25%, 75% {transform: scaleY(0.4);} 50% {transform: translateY(50%) scaleY(0.2)} }
`